class DeliveryComputation {
    computeHumidityWeight(humidity: number, weight: number): number {
        var correctedHumidity = 0;
        if (humidity == null || humidity < 0){
            return correctedHumidity
        }
        else if (humidity >= 12 || humidity < 10) {
            correctedHumidity = ((humidity - 10) * weight)/100;
        } 
        return correctedHumidity;
    }

    computedCorrectedWeight(correctedHumidity: number, weight: number): number {
        return weight - correctedHumidity;
    }
}

export const deliveryComputation = new DeliveryComputation(); 